import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForTranslationsRPC } from "./getPresignedDownloadUrlForTranslationsRPC";

export class GetPresignedDownloadURLForTranslationsRPCClientImpl extends GetPresignedDownloadURLForTranslationsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForTranslationsRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForTranslationsRPC.Response, GetPresignedDownloadURLForTranslationsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetPresignedDownloadURLForTranslations",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForTranslationsRPC.ResponseDTO,
      GetPresignedDownloadURLForTranslationsRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForTranslationsRPC.Response,
      GetPresignedDownloadURLForTranslationsRPC.Errors.Errors
    >(
      response,
      "survey/GetPresignedDownloadURLForTranslations",
      GetPresignedDownloadURLForTranslationsRPC.Response.fromDTO,
      GetPresignedDownloadURLForTranslationsRPC.Errors.fromDTO
    );
  }
}
